import React from 'react';
import useVideoContext from '../../../src/hooks/useVideoContext/useVideoContext';
import AudioLevelIndicator from '../AudioLevelIndicator/AudioLevelIndicator';
import { useParticipants } from '../../main';
import usePublications from '../../../src/hooks/usePublications/usePublications';
import useTrack from '../../../src/hooks/useTrack/useTrack';
export default function LocalAudioLevelIndicator(props) {
    var _a;
    const { localTracks, room: { localParticipant } } = useVideoContext();
    const participants = useParticipants();
    // The identity string has the format of {attendeeId}.{video|phone}.{name}
    const phoneIdentityPrefix = ((_a = localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.identity) === null || _a === void 0 ? void 0 : _a.split('.')[0]) + '.phone.';
    // See if a phone participant exists
    const localPhoneAudioParticipant = participants.find((participant) => participant.identity.startsWith(phoneIdentityPrefix));
    const phonePublications = usePublications(localPhoneAudioParticipant !== null && localPhoneAudioParticipant !== void 0 ? localPhoneAudioParticipant : localParticipant);
    const audioPublication = phonePublications === null || phonePublications === void 0 ? void 0 : phonePublications.find(p => p.kind === 'audio');
    const phoneAudioTrack = useTrack(audioPublication);
    const audioTrack = localPhoneAudioParticipant ? phoneAudioTrack
        : localTracks.find(track => track.kind === 'audio');
    return (React.createElement(AudioLevelIndicator, Object.assign({ audioTrack: audioTrack, isPhoneAudio: Boolean(localPhoneAudioParticipant) }, props)));
}
//# sourceMappingURL=LocalAudioLevelIndicator.js.map